// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__-I1_L","disabled":"FileBtn_disabled__2yEt8","warn":"FileBtn_warn__2B_GS","fade":"FileBtn_fade__3av_B"};